import { Type, Dom, Loc, Uri, ajax } from 'main.core';
import { EventEmitter } from 'main.core.events';
import { MessageBox, MessageBoxButtons } from 'ui.dialogs.messagebox';
import { BudgetRecalculate } from 'fusion.project.budget-recalculate';

import './style.css';

export class Manager
{
	static editProject(
		projectId = 0,
		params = {}
	) {
		let url  = Loc.getMessage(
			'JS_FUSION_PROJECT_MANAGER_PATH_TO_PROJECT_DETAIL', {
				'#PROJECT_ID#': projectId,
			}
		);

		if (Type.isStringFilled(url))
		{
			let uri = new Uri(url);

			if ( params.hasOwnProperty('from_workgroup_id') )
			{
				uri.setQueryParam('from_workgroup_id', BX.prop.getInteger(params, 'from_workgroup_id', 0));
			}

			if ( params.hasOwnProperty('type_id') )
			{
				uri.setQueryParam('type_id', BX.prop.getInteger(params, 'type_id', 0));
			}

			BX.SidePanel.Instance.open(uri.toString(), {
				width: 1200,
				cacheable: false,
				copyLinkLabel: true,
				allowChangeHistory: false,
				events: {
					onCloseComplete: (event) => {
						const sliderData = event.getSlider().getData();

						if (sliderData.get('saveSuccess')) {
							EventEmitter.emit('BX.Fusion.Project.Manager:onProjectSave', {});
						}
					}
				}
			});
		} else {
			MessageBox.show({
				title: Loc.getMessage('JS_FUSION_PROJECT_MANAGER_ERROR_POPUP_TITLE'),
				message: 'URL not found',
				buttons: MessageBoxButtons.OK,
			});
		}
	}

	static editProjectEstimate(projectId) {
		let url = Loc.getMessage(
			'JS_FUSION_PROJECT_MANAGER_PATH_TO_PROJECT_ESTIMATE', {
				'#PROJECT_ID#': projectId,
			}
		);

		if (Type.isStringFilled(url)) {
			BX.SidePanel.Instance.open(url, {
				// width: 1200,
				cacheable: false,
				allowChangeHistory: false,
				events: {
					onCloseComplete: (event) => {
						const sliderData = event.getSlider().getData();

						if (sliderData.get('saveSuccess')) {
							EventEmitter.emit(
								'BX.Fusion.Project.Manager:onProjectEstimateSave', {

								}
							);
						}
					}
				}
			});
		} else {
			MessageBox.show({
				title: Loc.getMessage('JS_FUSION_PROJECT_MANAGER_ERROR_POPUP_TITLE'),
				message: 'URL not found',
				buttons: MessageBoxButtons.OK,
			});
		}
	}

	static editProjectParticipants(projectId) {
		let url = Loc.getMessage(
			'JS_FUSION_PROJECT_MANAGER_PATH_TO_PROJECT_PARTICIPANTS', {
				'#PROJECT_ID#': projectId,
			}
		);

		if (Type.isStringFilled(url)) {
			BX.SidePanel.Instance.open(url, {
				width: 600,
				cacheable: false,
				allowChangeHistory: false,
				events: {
					onCloseComplete: (event) => {
						const sliderData = event.getSlider().getData();

						if (sliderData.get('saveSuccess')) {
							EventEmitter.emit(
								'BX.Fusion.Project.Manager:onProjectParticipantsSave', {

								}
							);
						}
					}
				}
			});
		} else {
			MessageBox.show({
				title: Loc.getMessage('JS_FUSION_PROJECT_MANAGER_ERROR_POPUP_TITLE'),
				message: 'URL not found',
				buttons: MessageBoxButtons.OK,
			});
		}
	}

	static showProjectHistory(projectId) {
		let url = Loc.getMessage(
			'JS_FUSION_PROJECT_MANAGER_PATH_TO_PROJECT_HISTORY', {
				'#PROJECT_ID#': projectId,
			}
		);

		if (Type.isStringFilled(url)) {
			BX.SidePanel.Instance.open(url, {
				width: 1200,
				cacheable: false,
				allowChangeHistory: false,
				events: {
					onCloseComplete: (event) => {
						const sliderData = event.getSlider().getData();

					}
				}
			});
		} else {
			MessageBox.show({
				title: Loc.getMessage('JS_FUSION_PROJECT_MANAGER_ERROR_POPUP_TITLE'),
				message: 'URL not found',
				buttons: MessageBoxButtons.OK,
			});
		}
	}

	static recalculateProjectBudget( projectId )
	{
		BudgetRecalculate.forProject(projectId)
			.then((response)=> {
				document.location.reload(true);
			})
			.catch((response)=>{
				console.log(response);
			});
	}

	static editStage(
		stageId,
		params = {}
	) {
		let url = Loc.getMessage(
			'JS_FUSION_PROJECT_MANAGER_PATH_TO_STAGE_DETAIL', {
				'#STAGE_ID#': stageId,
			}
		);

		if (Type.isStringFilled(url)) {
			const urlParams = {};

			if (!Type.isNil(params.PROJECT_ID)) {
				urlParams.PROJECT_ID = params.PROJECT_ID;
			}

			url = Uri.addParam(url, urlParams);

			BX.SidePanel.Instance.open(url, {
				width: 1200,
				cacheable: false,
				allowChangeHistory: false,
				events: {
					onCloseComplete: (event) => {
						const sliderData = event.getSlider().getData();

						if (sliderData.get('saveSuccess')) {
							EventEmitter.emit(
								'BX.Fusion.Project.Manager:onStageSave', {

								}
							);
						}
					}
				}
			});
		} else {
			MessageBox.show({
				title: Loc.getMessage('JS_FUSION_PROJECT_MANAGER_ERROR_POPUP_TITLE'),
				message: 'URL not found',
				buttons: MessageBoxButtons.OK,
			});
		}
	}

	static showStageHistory(stageId) {
		let url = Loc.getMessage(
			'JS_FUSION_PROJECT_MANAGER_PATH_TO_STAGE_HISTORY', {
				'#STAGE_ID#': stageId,
			}
		);

		if (Type.isStringFilled(url)) {
			BX.SidePanel.Instance.open(url, {
				width: 1200,
				cacheable: false,
				allowChangeHistory: false,
				events: {
					onCloseComplete: (event) => {
						const sliderData = event.getSlider().getData();

					}
				}
			});
		} else {
			MessageBox.show({
				title: Loc.getMessage('JS_FUSION_PROJECT_MANAGER_ERROR_POPUP_TITLE'),
				message: 'URL not found',
				buttons: MessageBoxButtons.OK,
			});
		}
	}

	static recalculateStageBudget( stageId )
	{
		BudgetRecalculate.forStage(stageId)
			.then((response)=> {
				document.location.reload(true);
			})
			.catch((response)=>{
				console.log(response);
			});
	}


	static editJob(
		jobId,
		params = {}
	) {
		let url = Loc.getMessage(
			'JS_FUSION_PROJECT_MANAGER_PATH_TO_JOB_DETAIL', {
				'#JOB_ID#': jobId,
			}
		);

		if (Type.isStringFilled(url)) {
			const urlParams = {};

			if (!Type.isNil(params.PROJECT_ID)) {
				urlParams.PROJECT_ID = params.PROJECT_ID;
			}

			url = Uri.addParam(url, urlParams);

			BX.SidePanel.Instance.open(url, {
				width: 1200,
				cacheable: false,
				allowChangeHistory: false,
				copyLinkLabel: true,
				events: {
					onCloseComplete: (event) => {
						const sliderData = event.getSlider().getData();

						if (sliderData.get('saveSuccess')) {
							EventEmitter.emit(
								'BX.Fusion.Project.Manager:onJobSave', {
									
								}
							);
						}
					}
				}
			});
		} else {
			MessageBox.show({
				title: Loc.getMessage('JS_FUSION_PROJECT_MANAGER_ERROR_POPUP_TITLE'),
				message: 'URL not found',
				buttons: MessageBoxButtons.OK,
			});
		}
	}

	static deleteJob(jobId) {
		MessageBox.show({
			title: Loc.getMessage('JS_FUSION_PROJECT_MANAGER_JOB_CONFIRM_DELETE_TITLE'),
			message: Loc.getMessage('JS_FUSION_PROJECT_MANAGER_JOB_CONFIRM_DELETE_MESSAGE'),
			buttons: MessageBoxButtons.YES_NO,
			onYes: (messageBox, button, event) => {
				button.setWaiting();

				messageBox.getButtons()
					.forEach(
						(button) => {
							if (button.isWaiting()) {
								return;
							}

							button.setDisabled(true);
						}
					);

				BX.ajax.runAction(
					'fusion:project.Job.delete',
					{
						data: {
							id: jobId
						}
					}
				).then(
					(response) => {
						messageBox.close();

						EventEmitter.emit('BX.Fusion.Project.Manager:onJobDelete', {});
					},
					(response) => {
						var errors = [];

						for (var i = 0; i < response.errors.length; i++)
						{
							errors.push(
								BX.util.nl2br(response.errors[i].message)
							);
						}

						messageBox.close();

						MessageBox.show({
							title: Loc.getMessage('JS_FUSION_PROJECT_MANAGER_ERROR_POPUP_TITLE'),
							message: errors.join('<br><br>'),
							buttons: MessageBoxButtons.OK,
							onOk: (errorMessageBox, errorMessageBoxButton, errorMessageBoxEvent) => {
								errorMessageBox.close();
							}
						});
					}
				);
			},
		});

	}

	static showJobHistory(jobId) {
		let url = Loc.getMessage(
			'JS_FUSION_PROJECT_MANAGER_PATH_TO_JOB_HISTORY', {
				'#JOB_ID#': jobId,
			}
		);

		if (Type.isStringFilled(url)) {
			BX.SidePanel.Instance.open(url, {
				width: 1200,
				cacheable: false,
				allowChangeHistory: false,
				copyLinkLabel: true,
				events: {
					onCloseComplete: (event) => {
						const sliderData = event.getSlider().getData();

					}
				}
			});
		} else {
			MessageBox.show({
				title: Loc.getMessage('JS_FUSION_PROJECT_MANAGER_ERROR_POPUP_TITLE'),
				message: 'URL not found',
				buttons: MessageBoxButtons.OK,
			});
		}
	}

	static recalculateJobBudget( jobId )
	{
		BudgetRecalculate.forJob(jobId)
			.then((response)=> {
				document.location.reload(true);
			})
			.catch((response)=>{
				console.log(response);
			});
	}

	static openUserfieldConfig(event, menuItem)
	{
		this.getParentMenuWindow().close();

		let url = Loc.getMessage(
			'JS_FUSION_PROJECT_MANAGER_PATH_TO_USERFIELD_CONFIG', {
				'#ENTITY_ID#': menuItem.dataset.userfield,
			}
		);

		BX.SidePanel.Instance.open(url, {
			width: 1200,
			cacheable: false,
			allowChangeHistory: false,
		});
	}
}